@for (familyTypeKey of colorFamilyTypeKeys(); track $index) {
  <h2 [attr.data-test-id]="'colorFamilies.pageHeader.' + familyTypeKey">{{ familyTypeKey }}</h2>
  <ppg-color-family-switcher
    [selectedColorFamily]="getSelectedColorFamily(familyTypeKey)"
    [colorFamilies]="colorFamiliesGroupedByType()[familyTypeKey] | sortBy: 'structureGroupId'"
    [customStyle]="customStyle()"
    (colorFamilySelected)="onColorFamilySelected(familyTypeKey, $event)">
  </ppg-color-family-switcher>
}
